import { useLocation } from "react-router-dom";

export function useMenu() {
  const location = useLocation();

  return {
    isCurrentItem: (path: string) => !!(location.pathname.indexOf(path) + 1),
  }
}
